// extracted by mini-css-extract-plugin
export default {"container":"CircleProgressBar_container__TWSaU","small":"CircleProgressBar_small__Inpvp","circle":"CircleProgressBar_circle__8Smhb","inner":"CircleProgressBar_inner__REN8P"};